export default "__VITE_ASSET__bcdad794__"